// TODO: move to monolu all of these

type EasingFunction = (t: number) => number; // TODO: move to monolu

export type Range<Min extends number = number, Max extends number = number> = [Min, Max];
type RangeMap = {
  x: Range;
  y: Range;
};

interface Segment {
  range: Range;
}

interface SegmentWithSpeed extends Segment {
  speed: number;
}

export type Giveback2021Segment = SegmentWithSpeed & {
  easing: EasingFunction;
};

type SegmentWithWeight = {
  range: Range;
  weight: number;
};

type Vector = { x: number; y: number };

export function verifyContinuousRangedSegments(segments: Segment[]): boolean {
  // verify segments begin with 0 and end with 1
  if (segments[0].range[0] !== 0) return false;
  if (segments[segments.length - 1].range[1] !== 1) return false;

  for (let i = 0; i < segments.length; i++) {
    // verify each segment range is defined as [min,max]
    if (segments[i].range[0] > segments[i].range[1]) return false;
  }

  for (let i = 1; i < segments.length; i++) {
    // verify segments are continuous
    if (segments[i].range[0] !== segments[i - 1].range[1]) return false;
  }
  return true;
}

export function speedRangesToWeightedRanges(segments: SegmentWithSpeed[]): SegmentWithWeight[] {
  return segments.map(({ range, speed }) => ({ range, weight: 1 / speed }));
}

export function weightRangesToCoordinates(segments: SegmentWithWeight[]): Vector[] {
  // what's going on here?
  // we have different segments in different lengths but possibly different speeds
  // (e.g. a segment with speed 0.5 should stay twice as long as a segment with 1 speed).
  // in order to normalize all the segments duration to 1 we need to calculate:
  // - the relative speed weight of the segment (`RW(i)`).
  // - the relative length of the segment (`RL(i)`).
  // - a multiplier that contracts or expands the segment in order to normalize the equation (`xMultiplier`).
  // in order to find the right mapped coordinate for each segment `i` we need to calculate `RW(i)*RL(i)*xMultiplier`.
  const totalWeight = segments.reduce<number>((sum, { weight }) => sum + weight, 0);
  const segmentsRelativeWeights = segments.map(({ weight }) => weight / totalWeight);
  const segmentsRelativeLengths = segments.map(({ range }) => range[1] - range[0]);
  const xMultiplier =
    1 /
    segmentsRelativeWeights.reduce<number>((sum, weight, index) => sum + weight * segmentsRelativeLengths[index], 0);

  return segments.reduce<Vector[]>(
    (coordinates, segment, index) => {
      return [
        // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
        ...coordinates,
        {
          y: segment.range[1],
          x: coordinates[index].x + xMultiplier * segmentsRelativeLengths[index] * segmentsRelativeWeights[index],
        },
      ];
    },
    [{ x: 0, y: 0 }],
  );
}

export function pointsToRangeMaps(points: Vector[]): RangeMap[] {
  const rangeMaps: RangeMap[] = [];
  for (let index = 0; index < points.length - 1; index++) {
    const point = points[index];
    rangeMaps.push({
      x: [point.x, points[index + 1].x],
      y: [point.y, points[index + 1].y],
    });
  }
  return rangeMaps;
}
